import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Img from "react-cool-img";

import Linkify from 'react-linkify';
import { useTranslation } from 'react-i18next/hooks';

import Button from '../../../../Button/Button';
import GroupTextNameIcons from '../GroupTextNameIcons';

import { useStore } from '../../../../../hook-store/store';
import { getDateTime } from '../../../../../util/timeFormat';
import { scrollToTextListRefItem } from '../../../../../util/group/group-text-list';

import { marks } from '../../../../../images/marks';
import classes from '../GroupTalkTextItem.module.css';

import SampleImage from "../../../../Image/person-icon-50.jpg";

const GroupTextItemReplys = (props) => {
  // console.log('GroupTalkTextItem-props', props);

  const { 
    inputData, 
    // userId, 
    // userColorList, 
    // allMemberUserIds,
    // groupTextReactions,
    // createGroupTextReactionHandler,
    // groupTextDeleteHandler,
    lsNameDataList,
    // replyTexts,
    setShowTextSettings,
    // groupTextPostHandler,
    // isTextPosting,
    // isLoading,
   } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const {
    selectedGroupData,
    groupTextItemRef,
  } = store.groupStore;
  // console.log('store in GroupTalkTextItem', store);
  
  const [replyTexts, setReplyTexts] = useState([]);
  const [showReplyList, setShowReplyList] = useState(false);
  const [showReplyAllTextId, setShowReplyAllTextId] = useState('');
  const [replyToReplys, setReplyToReplys] = useState([]);

  useEffect(() => {
    if (selectedGroupData && selectedGroupData.talks && selectedGroupData.talks.length > 0) {
      
      const replyItems = [];
      
      for (const text of selectedGroupData.talks) {
        const replyInfo = text.replyInfo;

        if (replyInfo && replyInfo.originalTextId === inputData._id) {
          // console.log(replyInfo.originalTextId, inputData._id)
          replyItems.push(text);
        }

        if (replyItems.length > 0) {
          setReplyTexts(replyItems);
        }
      }
    }
  },[selectedGroupData]);

  useEffect(() => {
    if (replyTexts && replyTexts.length > 0) {
      // console.log('replyTexts', replyTexts)

      const allReplyToReplys = [];

      for (const replyText of replyTexts) {
        const replyTextId = replyText._id;

        const replyToReplyItems = [];

        if (selectedGroupData && selectedGroupData.talks && 
              selectedGroupData.talks.length > 0
        ) {
      
          for (const text of selectedGroupData.talks) {
            const replyInfo = text.replyInfo;
  
            if (replyInfo && replyInfo.originalTextId === replyTextId) {
              // console.log(replyInfo.originalTextId, inputData._id)
              
              replyToReplyItems.push(text);
            }
          }
          // console.log('replyToReplyItems', replyToReplyItems, nameDataList)
          
          allReplyToReplys.push({
            replyTextId: replyTextId,
            replyToReplys: replyToReplyItems,
          });
        }
      }
      // console.log('allReplyToReplys', allReplyToReplys)
      setReplyToReplys(allReplyToReplys);
    }

  },[replyTexts]);

  const componentDecorator = (href, text, key) => (
    <a href={href} key={key} target="_blank" rel="noopener noreferrer" style={{color: 'gray', fontWeight: ''}}>
        {text}
    </a>
  );

  const scrollToReplyTextHandler = (id) => {
    const isScrolled = scrollToTextListRefItem(
                        groupTextItemRef,
                        id
                      );
    
    const scrolledMessge = (
      <div>
        <span
          onClick={() => {
            scrollToTextListRefItem(
                groupTextItemRef,
                inputData._id
              );

            dispatch('CLEAR_NOTIFICATION');
          }}
        >
          {t('groupTalk.text107', 'Back to post')}
        </span>
      </div>
    );

    if (isScrolled) {
      dispatch('SHOW_NOTIFICATION', {
        status: '',
        // title: 'scrolled to item',
        title: scrolledMessge,
        message: '',
      });

      setShowTextSettings(false);

    } else {
      // dispatch('SHOW_NOTIFICATION', {
      //   status: '',
      //   title: 'failed to scrolled to item',
      //   message: '',
      // });
    }
  };



    // const lsDarkMode = localStorage.getItem('darkMode');
    // if (lsDarkMode) {
    //   colorStyle = null;
    // }

    // console.log('darkMode, colorStyle', localStorage.getItem('darkMode'), colorStyle);
    // console.log('userColor[0]', userColorList[0].bgColor);
  const sendTime = new Date(inputData.sendAt);

  let [month, date, year] = (new Date(inputData.sendAt)).toLocaleDateString().split("/")
  let [hour, minute, second] = (new Date(inputData.sendAt)).toLocaleTimeString().slice(0, 7).split(":")
  let xm = (new Date(inputData.sendAt)).toLocaleTimeString().split(' ')[1];
  

  let nameData;
  if (lsNameDataList && JSON.parse(lsNameDataList).length > 0) {
    nameData = JSON.parse(lsNameDataList).find(ele => {
      return ele.userId === inputData.fromUserId;
    });
  }










  let groupTextItemReplysBody;
  if (replyTexts && replyTexts.length === 0) {
    groupTextItemReplysBody = (
      <div>
        <div className={classes.groupTalkTextItemTextDeleteButton}
          style={{ color: "gray" }}
        >
          {marks.replyAllMark}{' '} 
          {t('groupTalk.text105', 'Replys for this post')}
          {' '}({replyTexts.length})
        </div>
      </div>
    );
  }

  if (replyTexts && replyTexts.length > 0) {
    groupTextItemReplysBody = (
      <div>
        <div className={classes.groupTalkTextItemTextDeleteButton}
          onClick={() => {
            setShowReplyList(!showReplyList)
          }}
        >
          {marks.replyAllMark}{' '} 
          {t('groupTalk.text105', 'Replys for this post')}
          {' '}({replyTexts.length})
          {' '}{marks.triangleDown} 
        </div>
        {showReplyList && (
          <ul className={classes.groupTextItemReplyList}>
            {replyTexts.map(rText => {
              let replyUserNameData 
              
              if (lsNameDataList) {
                replyUserNameData = JSON.parse(lsNameDataList).find(ele => {
                  return ele.userId === rText.fromUserId;
                });
              }

              let replyTextContent;

              if (rText.text) {
                if (rText.text.length > 50 && showReplyAllTextId !== rText._id) {
                  replyTextContent = (
                    <span
                      // onClick={() => {
                      //   setShowReplyAllTextId(rText._id);
                      // }}
                    >
                      {rText.text.slice(0,50)}....
                      <br/>
                      <span
                        onClick={() => {
                          setShowReplyAllTextId(rText._id);
                        }}
                      >
                        {' '}({marks.triangleDown} {t("groupTalk.text109","display more")})
                      </span>
                    </span>
                  );
                } else {
                  replyTextContent = (
                  <span
                    // onClick={() => {
                    //   setShowReplyAllTextId('');
                    // }}
                    style={{whiteSpace: "pre-wrap"}}
                  >
                    <Linkify componentDecorator={componentDecorator}>
                      {rText.text}
                    </Linkify>
                  </span>
                );
                }
              }

              let replyToReplyTexts = [];
              let replyToReplyNameIcons;

              const replyToReplyData = replyToReplys.find(element => {
                return rText._id === element.replyTextId;
              });

              if (replyToReplyData && replyToReplyData.replyToReplys &&
                replyToReplyData.replyToReplys.length > 0
              ) {
                replyToReplyTexts = replyToReplyData.replyToReplys;
              }

              if (replyToReplyTexts.length > 0) {
                replyToReplyNameIcons = (
                  <GroupTextNameIcons 
                    lsNameDataList={lsNameDataList}
                    textList={replyToReplyTexts}
                    size={1}
                    limit={3}
                  />
                )
              }

              return (
                <li className={classes.groupTextItemReplyListItem}
                  key={rText._id}
                >
                  <div>
                    <div className={classes.groupTextItemReplyListItemRow}>
                      {replyTextContent} 
                    </div>
                    {replyUserNameData && (
                      <div>
                        <div className={classes.groupTextItemReplyListItemRow}>
                          <div className={classes.groupTextItemReplyListNameRow}>
                            {replyUserNameData.name}
                            {replyUserNameData.imageUrl && (
                              <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                                src={replyUserNameData.imageUrl}
                              />
                            )}
                            {!replyUserNameData.imageUrl && (
                              <Img style={{height: "1.25rem", width:"1.25rem", objectFit: "cover"}}
                                src={SampleImage}
                              />
                            )}
                          </div>
                          <div className={classes.groupTalkTextItmeTimeElement}>
                              {/* {month}/{date} {hour}:{minute} {xm} */}
                              {getDateTime( new Date(rText.sendAt) )}
                          </div>
                        </div>
                      </div>
                    )}


                    {replyToReplyTexts.length > 0 && (
                      <div className={classes.groupTextItemReplyNameInfoRow}>
                        <span>
                          {replyToReplyTexts.length}{' '}
                            {t("groupTalk.text108","reply messages to this post")} 
                        </span>
                        <span>
                          {replyToReplyNameIcons}
                        </span>
                      </div>
                    )}

                    <div 
                      className={classes.groupTextItemReplyListButton}
                    >
                      <Button mode="" type="" size="smaller"
                        onClick={() => {
                          scrollToReplyTextHandler(rText._id)
                        }}
                      >
                        {t('groupTalk.text106', 'Go to post')}
                      </Button>
                    </div>

                  </div>
                </li>
              );
          })}
          </ul>
        )}
      </div>
    );
  }

 
  return (
    <Fragment>
      {groupTextItemReplysBody}
    </Fragment>
  );
}

export default GroupTextItemReplys;